import { createApp } from 'vue';
import OggToOpusConverter from '@/Components/OggToOpusConverter.vue';
import '@styles/app.css';

createApp(OggToOpusConverter).mount('#ogg-to-opus-converter');
